import React, { useEffect, useState } from "react";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { Button, DropdownButton, Dropdown, ButtonGroup } from "react-bootstrap";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { useAppDispatch } from "../../store/store";
import { Link } from "react-router-dom";

import "./LoginTrueNavBtns.css";
import { logout, reset } from "../../features/auth/authSlice";
import { reset as resetCart } from "../../features/cart/cartSlice";
import { generateIntials } from "../../features/utils";

export default function LoginTrueNavBtns() {
  const dispatch = useAppDispatch();
  const [profileClick, setProfileClick] = useState(false);
  const initials = generateIntials() || "U";
  const user = localStorage.getItem("user");
  const userObj = user ? JSON.parse(user) : null;
  useEffect(() => {
    function handleClickOutside(event) {
      if (!event.target.closest(".user-btn")) {
        // Clicked outside the profile button, hide profile buttons
        setProfileClick(false);
      }
    }

    document.body.addEventListener("click", handleClickOutside);
    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, []);
  return (
    <>
      <div className="loginBtns">
        <div className="top-link-text">My Learning</div>
        <div className="top-icon-wrap">
          {" "}
          <Link to="/cart">
            <ShoppingCartOutlinedIcon className="top-nav-icon" />
          </Link>
        </div>
        <NotificationsActiveIcon className="notifBtn top-nav-icon me-2" />
        <div className="navBarBtn">
          <div
            className="user-btn"
            onClick={() => setProfileClick(!profileClick)}
          >
            {initials}
          </div>
          <div
            className={`${
              profileClick ? "profile-btns" : "profile-btns-hidden"
            }`}
          >
            <div className="profile-header">
              <div className="profile-mini-avatar">{initials}</div>
              <div className="profile-meta">
                <div className="profile-name">{userObj?.name || "User"}</div>
                <div className="profile-subtitle">Welcome back</div>
              </div>
            </div>
            <hr className="profile-separator" />
            <div className="profile-item">My learning</div>
            <div className="profile-item">
              <Link to="/cart">My Cart</Link>
            </div>
            <hr className="profile-separator" />
            <div
              className="profile-item profile-logout"
              onClick={() => {
                dispatch(logout());
                dispatch(reset());
                dispatch(resetCart());
              }}
            >
              Log out
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
